import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-mainMenu__listItem"
}
const _hoisted_2 = { class: "m-mainMenu__listItemLabel" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "m-mainMenu__listItemLabel"
}
const _hoisted_5 = ["href", "aria-label", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "o-mainHeader__utilitiesNavItemDot"
}
const _hoisted_7 = { class: "m-mainMenu__listItemTitleText" }
const _hoisted_8 = ["href", "aria-label", "onClick"]
const _hoisted_9 = { class: "m-mainMenu__listItemRow" }
const _hoisted_10 = {
  key: 0,
  class: "o-mainHeader__utilitiesNavItemDot"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "a-iconArr icon-darr"
}
const _hoisted_13 = {
  key: 0,
  class: "m-mainMenu__listItemSubListItem is-mobile"
}
const _hoisted_14 = ["href", "aria-label", "onClick"]
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = {
  key: 1,
  class: "m-mainMenu__listItem"
}
const _hoisted_17 = { class: "m-mainMenu__listItemTitle" }
const _hoisted_18 = {
  class: "m-mainMenu__listItemTitle",
  href: '?switch_language'
}
const _hoisted_19 = ["href", "aria-label", "onClick"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 1,
  class: "m-mainMenu__bottom"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 2,
  class: "m-mainMenu__bottom"
}
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = ["href", "aria-label"]
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = {
  key: 1,
  class: "m-mainMenu__list"
}
const _hoisted_28 = ["href", "aria-label", "onClick"]
const _hoisted_29 = ["href", "aria-label", "onClick"]
const _hoisted_30 = { class: "m-mainMenu__listItemRow" }
const _hoisted_31 = {
  key: 0,
  class: "a-iconArr icon-rarr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['m-mainMenu', {'has-promotions': _ctx.hasPromotions}])
  }, [
    (_ctx.filteredActiveSection)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("ul", {
            class: _normalizeClass([
                'm-mainMenu__list', _ctx.filteredActiveSection.name,
                {'has-children': !_ctx.isActiveSection(_ctx.MainMenuSection.Profile)}
            ])
          }, [
            (_ctx.isActiveSection(_ctx.MainMenuSection.Profile) && _ctx.loggedIn)
              ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createTextVNode("Profile:")
                  ])), [
                    [_directive_translate, { key: _ctx.Translation.Account_section_title }]
                  ]),
                  _createElementVNode("strong", {
                    class: "m-mainMenu__listItemText is-clipped-rtl",
                    title: _ctx.userStatus?.username
                  }, _toDisplayString(_ctx.userStatus?.username), 9, _hoisted_3)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredActiveSection.categories, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(['m-mainMenu__listItem', {'is-opened': item.showChildren, 'is-hidden': _ctx.isHidden(item)}])
              }, [
                (item.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h3", {
                  class: _normalizeClass(['m-mainMenu__listItemTitle', {'big-title': !_ctx.isActiveSection(_ctx.MainMenuSection.Profile)}])
                }, [
                  _createElementVNode("a", {
                    href: item.url,
                    "aria-label": item.title,
                    onClick: ($event: any) => (_ctx.categoryClick(item, $event))
                  }, [
                    (_ctx.canDisplayCartStatus(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                  ], 8, _hoisted_5)
                ], 2),
                _createElementVNode("a", {
                  class: _normalizeClass(['m-mainMenu__listItemTitle is-mobile', {'is-opened': item.showChildren}]),
                  href: item.url,
                  "aria-label": item.title,
                  onClick: ($event: any) => (_ctx.handeCategoryClick(item, $event))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.canDisplayCartStatus(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      innerHTML: item.title
                    }, null, 8, _hoisted_11),
                    (item.subCategories && item.subCategories.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.ArrowSlim
                          }, null, 8, ["icon-id"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_8),
                (item.subCategories.length)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 1,
                      class: _normalizeClass(['m-mainMenu__listItemSubList', {'is-opened': item.showChildren}])
                    }, [
                      (item.url)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                            _createElementVNode("a", {
                              href: item.url,
                              "aria-label": item.title,
                              onClick: ($event: any) => (_ctx.actionMenuItemClick(item))
                            }, [
                              _withDirectives(_createElementVNode("span", null, null, 512), [
                                [_directive_translate, { key: _ctx.Translation.Dropdown_all }]
                              ]),
                              _createTextVNode(" " + _toDisplayString(item.title), 1)
                            ], 8, _hoisted_14)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subCategories, (subitem, idx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: idx,
                          class: "m-mainMenu__listItemSubListItem"
                        }, [
                          _createElementVNode("a", {
                            href: subitem.url,
                            onClick: ($event: any) => (_ctx.actionMenuItemClick(subitem))
                          }, _toDisplayString(subitem.title), 9, _hoisted_15)
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (_ctx.isActiveSection(_ctx.MainMenuSection.Profile) && _ctx.languageConfiguration)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("h3", _hoisted_17, [
                    _createElementVNode("a", _hoisted_18, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.languageConfiguration.name), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.hasPromotions)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['m-mainMenu__promotions', _ctx.filteredActiveSection!.name])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.filteredActiveSection as MenuTitle).promotions, (promo, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    class: "m-mainMenu__promotionsItem",
                    href: promo.url,
                    "aria-label": promo.title,
                    onClick: ($event: any) => (_ctx.actionGA(_ctx.filteredActiveSection!.name ?? '', promo.title, +index))
                  }, [
                    _createElementVNode("img", {
                      src: promo.image,
                      alt: promo.title
                    }, null, 8, _hoisted_20)
                  ], 8, _hoisted_19))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.filteredActiveSection?.sectionButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("a", {
                  class: "m-mainMenu__bottomLink",
                  href: _ctx.filteredActiveSection?.sectionButton.url,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGACategoryClick('seeAll', _ctx.filteredActiveSection!.name ?? '')))
                }, _toDisplayString(_ctx.filteredActiveSection?.sectionButton.title), 9, _hoisted_22)
              ]))
            : (_ctx.isActiveSection(_ctx.MainMenuSection.Profile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_ctx.loggedIn)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "m-mainMenu__bottomLink",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLogout()))
                      }, [
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                          _createTextVNode("Logout")
                        ])), [
                          [_directive_translate, { key: _ctx.Translation.Logout }]
                        ]),
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.Logout
                          }, null, 8, ["icon-id"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "m-mainMenu__bottomLink",
                        href: _ctx.data.profile.loginUrl,
                        "aria-label": _ctx.data.profile.title,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleGACategoryClick('Login', _ctx.MainMenuSection.Profile)))
                      }, [
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                          _createTextVNode("Login")
                        ])), [
                          [_directive_translate, { key: _ctx.Translation.Login }]
                        ]),
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.Login
                          }, null, 8, ["icon-id"])
                        ])
                      ], 8, _hoisted_25))
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("ul", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.menu, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: idx,
              class: "m-mainMenu__listItem"
            }, [
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "m-mainMenu__listItemTitle",
                    href: item.url,
                    "aria-label": item.title,
                    onClick: ($event: any) => (_ctx.toggleContent(item.name, $event))
                  }, _toDisplayString(item.title), 9, _hoisted_28))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "m-mainMenu__listItemTitle is-mobile",
                    href: item.url,
                    "aria-label": item.title,
                    onClick: ($event: any) => (_ctx.toggleContent(item.name, $event))
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1),
                      (item.categories && item.categories.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createVNode(_component_IconComponent, {
                              "icon-id": _ctx.IconName.ArrowSlim
                            }, null, 8, ["icon-id"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_29))
            ]))
          }), 128))
        ]))
  ], 2))
}